import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Col, Table, Image, Button } from "react-bootstrap";
import moment from "moment";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useFormik } from "formik";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import { SuperAdminNotification } from "../../superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import BasicPagination from "../../../Pagination/Pagination";

import propTypes from "prop-types";
import { admin_get_all_order_dashboard } from "../../../../store/actions/SuperAdminActions/adminOrderingActivityDashboard";
import isEmpty from "../../../../store/validation/is-Empty";
import {
  ORDER_TYPE,
  PAYMENT_TYPE,
  PAYMENT_STATUS,
  ORDER_STATUS,
} from "../../../../enums/OrderEnums";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { SmallLoader } from "../../../Loader/SmallLoader";
import CallingButtonPopup from "../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import {
  create_and_update_restaurant,
  get_new_subscription_for_vendor,
} from "../../../../store/actions/authAction";
import { setVendorAccess } from "../../../../store/actions/vendorAccessActions";
import { useHistory } from "react-router-dom";
import { SuperAdminSMS } from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS";
import SendSMS from "../../superAdminReusable/reusablePopupSuperAdmin/SendSMS";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
// Animations

import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import NoContent from "../../../reusableComponents/NoContentComponent";

const zoomAnimation = keyframes`${zoomIn}`;

const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

// End Animations
function SuperAdminAllOrders(props) {
  const dispatch = useDispatch();

  /***************************************
   * @DESC GET ADMIN INFORMATION
   **************************************/

  const auth = useSelector((state) => {
    return !isEmpty(state?.auth) ? state?.auth : "";
  });

  /****************************************
   * @DESC Filter Section Action
   ****************************************/
  const [dateQuery, setDateQuery] = useState({
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };
  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      dispatch(
        admin_get_all_order_dashboard(
          auth.user.accessToken,
          dateQuery.startDate,
          dateQuery.endDate
        )
      );
    }
  }, [dateQuery]);

  /***************************************
   * @DESC GET ALL ORDERING DATA
   **************************************/
  useEffect(() => {
    dispatch(
      admin_get_all_order_dashboard(
        auth.user.accessToken,
        moment().format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      )
    );
  }, []);

  const allOrderingsActivity = useSelector((state) => {
    return !isEmpty(
      state?.superAdminOrderActivity?.admin_get_all_ordering_dashboard?.orders
    )
      ? state?.superAdminOrderActivity?.admin_get_all_ordering_dashboard?.orders
      : [];
  });

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(50);

  const handleBatchChange = (pageNo) => {
    var calcStart = pageNo * 50 - 50;
    setStart(calcStart);
    setEnd(pageNo * 50);
    setPage(pageNo);
  };

  const [showSMS, seShowSMS] = useState(false);
  const handleShowSMS = () => seShowSMS(true);

  /***************************************
   * @DESC ALL ORDER ACTIVITY COUNT
   **************************************/
  const activityCount = useSelector((state) => {
    return !isEmpty(
      state?.superAdminOrderActivity?.admin_get_all_ordering_dashboard?.stats
    )
      ? state?.superAdminOrderActivity?.admin_get_all_ordering_dashboard?.stats
      : "";
  });
  let takeAwayCount =
    activityCount && activityCount.findIndex((obj) => obj._id == 0);
  let curbSideCount =
    activityCount && activityCount.findIndex((obj) => obj._id == 1);
  let skipTheLineCount =
    activityCount && activityCount.findIndex((obj) => obj._id == 2);
  let dineInCount =
    activityCount && activityCount.findIndex((obj) => obj._id == 3);
  let homeDeliveryCount =
    activityCount && activityCount.findIndex((obj) => obj._id == 7);

  let totalCount =
    activityCount &&
    activityCount[takeAwayCount]?.count +
    activityCount[curbSideCount]?.count +
    activityCount[skipTheLineCount]?.count +
    activityCount[dineInCount]?.count +
    activityCount[homeDeliveryCount]?.count;

  let totalNewAmount =
    activityCount &&
    activityCount[takeAwayCount]?.totalAmount +
    activityCount[curbSideCount]?.totalAmount +
    activityCount[skipTheLineCount]?.totalAmount +
    activityCount[dineInCount]?.totalAmount +
    activityCount[homeDeliveryCount]?.totalAmount;

  const [state, setState] = useState({
    search: "",
    anchorEl: null,
    restaurantReverse: "",
    user_type: "",
    statusAction: "",
    showFilter: false,
    orderStatusType: "",
    orderPaymentType: "",
    showSearch: false,
  });

  /*********************************
   * @DESC Search Bar Action
   *********************************/
  const onSearchChange = (e) => {
    setState({
      ...state,
      search: e.target.value,
    });
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const handleClick = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
    });
  };

  const handleClose = () => {
    setState({
      ...state,
      anchorEl: null,
    });
  };

  const handleSelect = (value) => () => {
    setState({
      ...state,
      restaurantReverse: value,
      anchorEl: false,
    });
  };

  /******************************************
   * @DESC FILTER BUTTON ACTION
   *****************************************/
  const handleShowFilter = () => {
    setState({
      ...state,
      showFilter: !state.showFilter,
    });
  };

  const SetFormikDataState = (data) => {
    setState({
      ...state,
      showFilter: false,
      orderStatusType: data.values.orderStatusType,
      orderPaymentType: data.values.orderPaymentType,
    });
  };

  const formik = useFormik({
    initialValues: {
      orderStatusType: "",
      orderPaymentType: "",
    },

    onSubmit: (values) => {
      formik.orderStatusType = values.orderStatusType;
      formik.orderPaymentType = values.orderPaymentType;
      SetFormikDataState(formik);
    },
  });

  const [count, setCount] = useState(1);
  const onClickSave = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };
  /*************************************************
   * @DESC TABLE BODY COMPONENT FUNCTION
   *************************************************/
  const RenderTableBody = () => {
    const smsDataArr = allOrderingsActivity && allOrderingsActivity;
    let filteredData = [];
    if (state.restaurantReverse === "A-Z") {
      filteredData = smsDataArr.sort((a, b) => {
        const dataA = a.restaurant && a.restaurant[0];
        const dataB = b.restaurant && b.restaurant[0];
        if (dataA?.restaurant_name < dataB?.restaurant_name) return -1;
        if (dataA?.restaurant_name > dataB?.restaurant_name) return 1;
        return 0;
      });
    } else if (state.restaurantReverse === "Z-A") {
      filteredData = smsDataArr.sort((a, b) => {
        const dataA = a.restaurant && a.restaurant[0];
        const dataB = b.restaurant && b.restaurant[0];
        if (dataA?.restaurant_name < dataB?.restaurant_name) return 1;
        if (dataA?.restaurant_name > dataB?.restaurant_name) return -1;
        return 0;
      });
    }
    if (state.search) {
      let search = new RegExp(state.search, "i");
      filteredData = smsDataArr.filter((getall) => {
        const data = getall.restaurant;
        if (search.test(data && data.restaurant_name)) {
          return getall;
        } else {
          return false;
        }
      });
    }
    //  else if (state.orderStatusType !== "") {
    //   filteredData = smsDataArr.filter(
    //     (notification) => notification.order_type === state.orderStatusType
    //   );
    // } else if (state.orderPaymentType !== "") {
    //   filteredData = smsDataArr.filter(
    //     (notification) => notification.payment_method === state.orderPaymentType
    //   );
    // }
    else {
      filteredData = smsDataArr;
    }
    if (!isEmpty(filteredData)) {
      return (
        filteredData &&
        filteredData.slice(start, end).map((data, index) => (
          <React.Fragment key={index}>
            <TableBody orderInfo={data} />
          </React.Fragment>
        ))
      );
    }
  };

  const downloadData = {
    headers: [
      { label: "Restaurant Name", key: "name" },
      { label: "ID", key: "id" },
      { label: "No of Orders", key: "noOrders" },
      { label: "Order Amount", key: "orderAmount" },
      { label: "Pending Orders", key: "pending" },
      { label: "Skip the Line Orders", key: "skipCount" },
      { label: "Skip the Line Amount", key: "skipAmount" },
      { label: "Take Away Orders", key: "takeCount" },
      { label: "Take Away Amount", key: "takeAmount" },
      { label: "Curb Side Orders", key: "curbCount" },
      { label: "Curb Side Amount", key: "curbAmount" },
      { label: "Dine In Orders", key: "dineCount" },
      { label: "Dine In Amount", key: "dineAmount" },
      { label: "Home Delivery Orders", key: "homeDeliveryCount" },
      { label: "Home Delivery Amount", key: "homeDeliveryAmount" },
      { label: "Restaurant Type", key: "type" },
      { label: "Stauts", key: "status" },
    ],
    data: allOrderingsActivity
      ? allOrderingsActivity?.map((ele) => {
        return {
          name: ele?.restaurant?.restaurant_name,
          id: ele?.restaurant?._id,
          noOrders:
            ele?.SKIPTHELINE?.count +
            ele?.TAKEAWAY?.count +
            ele?.CURBSIDE?.count +
            ele?.DINEIN?.count +
            ele?.HOMEDELIVERY?.count,
          orderAmount: (
            ele?.SKIPTHELINE?.total +
            ele?.TAKEAWAY?.total +
            ele?.CURBSIDE?.total +
            ele?.DINEIN?.total +
            ele?.HOMEDELIVERY?.total
          ).toFixed(2),
          pending: ele?.PENDING?.count,
          skipCount: ele.SKIPTHELINE?.count,
          skipAmount: ele.SKIPTHELINE?.total?.toFixed(2),
          takeCount: ele.TAKEAWAY?.count,
          takeAmount: ele.TAKEAWAY?.total?.toFixed(2),
          curbCount: ele.CURBSIDE?.count,
          curbAmount: ele?.CURBSIDE?.total.toFixed(2),
          dineCount: ele?.DINEIN?.count,
          dineAmount: ele?.DINEIN?.total.toFixed(2),
          homeDeliveryCount: ele?.HOMEDELIVERY?.count,
          homeDeliveryAmount: ele?.HOMEDELIVERY?.total.toFixed(2),
          type: ele?.restaurant?.primary_food_type?.title,
          status: ele?.restaurant?.vendor_id?.has_admin_approved
            ? "True"
            : "False",
        };
      })
      : [],
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  All Ordering Dashboard
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col-5 d-flex align-items-end">
                  <Image
                    onClick={() =>
                      // this.setState({ showSearch: !this.state.showSearch })
                      setState({
                        ...state,
                        showSearch: !state.showFilter,
                      })
                    }
                    alt="filter"
                    title="filter"
                    width="80px"
                    src={require("../../../../assets/images/iconButton/searchbtn.svg")}
                  />
                  <div
                    className="f10-400"
                    align="center"
                    onClick={() => handleShowFilter()}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                      width="80px"
                    />
                    <br />
                    {/* Filter */}
                  </div>
                  <SortComponent
                    handleClick={handleClick}
                    anchorEl={state.anchorEl}
                    handleClose={handleClose}
                    selectClick={(data) => handleSelect(data)}
                  />
                  <CSVDownloader
                    filename={"allOrders"}
                    headers={downloadData.headers}
                    data={downloadData.data}
                  />
                </div>
                <div className="col-5"></div>
                <div className="col-2 p-0 m-0">
                  <div className="mr-3 d-flex align-items-center">
                    <SelectFilter onDateChange={onDateChangeHandler} />
                  </div>
                </div>
              </div>
              {state.showSearch && (
                <div className="mb-3">
                  <ZoomDiv>
                    <>
                      <br />
                      <Form.Control
                        type="text"
                        placeholder="Search by business name"
                        name="search"
                        onChange={onSearchChange}
                        value={state.search}
                        className="amSearch"
                      />
                    </>
                  </ZoomDiv>
                </div>
              )}
              {state.showFilter && (
                <div className="row">
                  <div className="col-12">
                    <div className="enWhiteBox mt-3">
                      <Form className="row justify-content-between">
                        <Col md={5}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Restaurant-type">
                                Order Type
                              </InputLabel>
                              <Select
                                value={formik.values.orderStatusType}
                                onChange={formik.handleChange}
                                label="User Type"
                                onBlur={formik.handleBlur}
                                inputProps={{
                                  name: "orderStatusType",
                                  id: "orderStatusType",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {ORDER_TYPE.map((data, index) => {
                                  return (
                                    <MenuItem value={index} key={index}>
                                      {data}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        <Col md={5}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Restaurant-type">
                                Payment Type
                              </InputLabel>
                              <Select
                                value={formik.values.orderPaymentType}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                label="Status"
                                inputProps={{
                                  name: "orderPaymentType",
                                  id: "orderPaymentType",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {PAYMENT_TYPE.map((data, index) => {
                                  return (
                                    <MenuItem value={index} key={index}>
                                      {data}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <div className="d-flex align-items-center">
                            <Button
                              variant="outline-secondary"
                              className="btn-lg mr-4 px-5"
                              onClick={() => handleShowFilter()}
                            >
                              Reset
                            </Button>
                            <Button
                              variant="danger"
                              className="btn-lg px-5"
                              onClick={(e) => onClickSave(e)}
                            >
                              Apply Filter
                            </Button>
                          </div>
                        </Col>
                      </Form>
                    </div>
                  </div>
                </div>
              )}
              <hr />
              <div>
                <div className="d-flex justify-content-end mt-3 mb-3">
                  <RightSideCountTop
                    content={[
                      {
                        name: "Home Delivery Order / Amount",
                        loader:
                          allOrderingsActivity &&
                            allOrderingsActivity.length >= 0
                            ? false
                            : true,
                        value: allOrderingsActivity?.length <= 0 ? '-' : `${activityCount &&
                            activityCount[homeDeliveryCount]?.count !== undefined
                            ? activityCount &&
                            activityCount[homeDeliveryCount]?.count
                            : "0"
                          } /₹ ${activityCount &&
                            activityCount[homeDeliveryCount]?.totalAmount !==
                            undefined
                            ? activityCount &&
                            activityCount[
                              homeDeliveryCount
                            ]?.totalAmount.toFixed(2)
                            : "0"
                          }`,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: "Curbside Orders/Amount",
                        loader:
                          allOrderingsActivity &&
                            allOrderingsActivity.length >= 0
                            ? false
                            : true,
                        value: allOrderingsActivity?.length <= 0 ? '-' : `${activityCount &&
                            activityCount[curbSideCount]?.count !== undefined
                            ? activityCount &&
                            activityCount[curbSideCount]?.count
                            : "0"
                          } /₹ ${activityCount &&
                            activityCount[curbSideCount]?.totalAmount !==
                            undefined
                            ? activityCount &&
                            activityCount[curbSideCount]?.totalAmount.toFixed(
                              2
                            )
                            : "0"
                          }`,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Dine-In Orders/Amount",
                        loader:
                          allOrderingsActivity &&
                            allOrderingsActivity.length >= 0
                            ? false
                            : true,
                        value: allOrderingsActivity?.length <= 0 ? '-' : `${activityCount &&
                            activityCount[dineInCount]?.count !== undefined
                            ? activityCount && activityCount[dineInCount]?.count
                            : "0"
                          } /₹ ${activityCount &&
                            activityCount[dineInCount]?.totalAmount !== undefined
                            ? activityCount &&
                            activityCount[dineInCount]?.totalAmount.toFixed(2)
                            : "0"
                          }`,
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                      {
                        name: "Skip the Line Order /Amount",
                        loader:
                          allOrderingsActivity &&
                            allOrderingsActivity.length >= 0
                            ? false
                            : true,
                        value: allOrderingsActivity?.length <= 0 ? '-' : `${activityCount &&
                            activityCount[skipTheLineCount]?.count !== undefined
                            ? activityCount &&
                            activityCount[skipTheLineCount]?.count
                            : "0"
                          } /₹ ${activityCount &&
                            activityCount[skipTheLineCount]?.totalAmount !==
                            undefined
                            ? activityCount &&
                            activityCount[
                              skipTheLineCount
                            ]?.totalAmount.toFixed(2)
                            : "0"
                          }`,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: "Take Away Orders/Amount",
                        loader:
                          allOrderingsActivity &&
                            allOrderingsActivity.length >= 0
                            ? false
                            : true,
                        value: allOrderingsActivity?.length <= 0 ? '-' : `${activityCount &&
                            activityCount[takeAwayCount]?.count !== undefined
                            ? activityCount &&
                            activityCount[takeAwayCount]?.count
                            : "0"
                          } /₹ ${activityCount &&
                            activityCount[takeAwayCount]?.totalAmount !==
                            undefined
                            ? activityCount &&
                            activityCount[takeAwayCount]?.totalAmount.toFixed(
                              2
                            )
                            : "0"
                          }`,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Total number of Orders",
                        loader:
                          allOrderingsActivity &&
                            allOrderingsActivity.length >= 0
                            ? false
                            : true,
                        value: allOrderingsActivity?.length <= 0 ? '-' : `${isNaN(totalCount) === true ? "0" : totalCount
                          } /₹ ${totalNewAmount && totalNewAmount !== undefined
                            ? totalNewAmount && totalNewAmount.toFixed(2)
                            : "0"
                          }`,
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                    ]}
                  />
                </div>
              </div>
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                <Table>
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "15%" }} className="f12-400 ml-4">
                        Business <br />
                        Name/ID
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Business <br />
                        Name
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        No. of <br />
                        Orders <br />& Amount
                      </td>
                      <td style={{ width: "7%" }} className="f12-400">
                        Pending <br />
                        Orders
                      </td>
                      <td style={{ width: "8%" }} className="f12-400">
                        Skip The <br />
                        line Orders <br />& Amount
                      </td>
                      <td style={{ width: "7%" }} className="f12-400">
                        Takeaway <br />
                        Orders <br />& Amount
                      </td>
                      <td style={{ width: "8%" }} className="f12-400">
                        Curb-side <br />
                        Orders <br />& Amount
                      </td>
                      <td style={{ width: "7%" }} className="f12-400">
                        Dine-IN <br />
                        Orders <br />& Amount
                      </td>
                      <td style={{ width: "7%" }} className="f12-400">
                        Home Delivery <br />
                        Orders <br />& Amount
                      </td>
                      <td style={{ width: "8%" }} className="f12-400">
                        Restaurant <br /> type
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Status
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        Actions
                      </td>
                    </tr>
                  </thead>
                  {auth.secondary_loader ? <SmallLoader /> : allOrderingsActivity.length > 0 ? RenderTableBody() : <NoContent />}
                </Table>
              </div>
              {state.search !== "" ||
                state.orderStatusType !== "" ||
                state.orderPaymentType !== "" ? (
                ""
              ) : (
                <div className="row">
                  <div className="col-12">
                    {allOrderingsActivity.length !== 0 ? (
                      <BasicPagination
                        totalRecords={allOrderingsActivity.length}
                        limit={50}
                        batch={page}
                        onBatchChange={(e) => handleBatchChange(e)}
                      />
                    ) : (
                      <>No Orders Data</>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

SuperAdminAllOrders.propTypes = {
  admin_get_all_activity: propTypes.func.isRequired,
};

export default SuperAdminAllOrders;

const TableBody = (props) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);

  const dispatch = useDispatch();
  const history = useHistory();

  const onViewDashboard = () => {
    history.push("/orderdashboard");
  };

  const auth = useSelector((state) => {
    return !isEmpty(state?.auth) ? state?.auth : "";
  });

  const vendorDashboard = (id) => () => {
    dispatch(create_and_update_restaurant({ vendor_id: id }));
    dispatch(get_new_subscription_for_vendor({ vendor_id: id }));
    dispatch(setVendorAccess(id, onViewDashboard));
  };

  let totalCount =
    props?.orderInfo?.BUFFET?.count +
    props?.orderInfo?.CATERING?.count +
    props?.orderInfo?.CURBSIDE?.count +
    props?.orderInfo?.DINEIN?.count +
    props?.orderInfo?.DRIVETHRU?.count +
    props?.orderInfo?.HOMEDELIVERY?.count +
    props?.orderInfo?.PENDING?.count +
    props?.orderInfo?.SKIPTHELINE?.count +
    props?.orderInfo?.TAKEAWAY?.count;
  let totalAmount =
    props?.orderInfo?.BUFFET?.total +
    props?.orderInfo?.CATERING?.total +
    props?.orderInfo?.CURBSIDE?.total +
    props?.orderInfo?.DINEIN?.total +
    props?.orderInfo?.DRIVETHRU?.total +
    props?.orderInfo?.HOMEDELIVERY?.total +
    props?.orderInfo?.SKIPTHELINE?.total +
    props?.orderInfo?.TAKEAWAY?.total;

  const makeCallingObject = (user) => {
    let formData = {};
    formData.user_details = {};
    formData.user_details.mobile_number =
      user?.restaurant?.vendor_id?.mobile_number;
    formData.user_details.country_code =
      user?.restaurant?.vendor_id?.country_code;
    formData.user_details.name = user?.restaurant?.restaurant_name;
    return formData;
  };

  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr className="sd_body_table-row" onClick={showTr}>
                <td style={{ width: "15%" }}>
                  <div className="vendor-main-section-one">
                    <div className="image-box text-break">
                      <div
                        className="Image-box-section"
                        style={{
                          borderRadius: "4px",
                          maxWidth: "53px",
                          maxHeight: "53px",
                        }}
                      >
                        <Image
                          fluid
                          alt="Restaurant Photo"
                          title={props?.orderInfo?.restaurant?.restaurant_name}
                          src={props?.orderInfo?.restaurant?.logo_url}
                        />
                        <div className="inside-image-box-discout">
                          <Image
                            fluid
                            alt="Discount Picture"
                            title="Discount Picture"
                            src={require("../../../../assets/images/superadmin/discount.svg")}
                          />
                        </div>
                      </div>
                      <div>
                        <h5 className="font_16_m mt-3">
                          #{props.orderInfo?.restaurant?.vendor_id?._id}
                        </h5>
                      </div>
                    </div>
                    <div className="start-rating-review-box mt-2">
                      <Image
                        fluid
                        alt="wait time"
                        title="wait time"
                        className="star-image-box mr-1"
                        src={require("../../../../assets/images/superadmin/star.svg")}
                      />
                      <h5 className="font_16_m d-flex align-items-center">
                        {props?.orderInfo?.restaurantrating.map(
                          (data, index) => {
                            return (
                              <React.Fragment key={index}>
                                {data.count.toFixed(2)}
                                <span className="w-100 font_10_r ml-1">
                                  ({data.reviews} reviews)
                                </span>
                              </React.Fragment>
                            );
                          }
                        )}
                      </h5>
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <h3 className="font_20_m">
                    {props?.orderInfo?.restaurant?.restaurant_name}
                  </h3>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {totalCount}
                    <br />₹ {totalAmount?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "7%" }}>
                  <div className="f12-500">
                    {props?.orderInfo?.PENDING?.count}
                  </div>
                </td>
                <td style={{ width: "8%" }}>
                  <div className="f12-500">
                    {props?.orderInfo?.SKIPTHELINE?.count}
                    <br />₹
                    {props?.orderInfo?.SKIPTHELINE?.total?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "7%" }}>
                  <div className="f12-500">
                    {props?.orderInfo?.TAKEAWAY?.count}
                    <br />₹{props?.orderInfo?.TAKEAWAY?.total?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "8%" }}>
                  <div className="f12-500">
                    {props?.orderInfo?.CURBSIDE?.count}
                    <br />₹{props?.orderInfo?.CURBSIDE?.total.toFixed(2)}
                  </div>
                </td>
                <td style={{ width: "7%" }}>
                  <div className="f12-500">
                    {props?.orderInfo?.DINEIN?.count}
                    <br />₹{props?.orderInfo?.DINEIN?.total.toFixed(2)}
                  </div>
                </td>
                <td style={{ width: "7%" }}>
                  <div className="f12-500">
                    {props?.orderInfo?.HOMEDELIVERY?.count}
                    <br />₹{props?.orderInfo?.HOMEDELIVERY?.total.toFixed(2)}
                  </div>
                </td>
                <td style={{ width: "8%" }}>
                  <div className="f12-500">
                    {
                      props?.orderInfo?.restaurant?.primary_restaurant_type
                        ?.title
                    }
                  </div>
                  <div className="f10-400">
                    {props?.orderInfo?.restaurant?.primary_cusine?.title}
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-between">
                    <Image
                      src={
                        props?.orderInfo?.restaurant?.primary_food_type?.icon
                      }
                      alt={
                        props?.orderInfo?.restaurant?.primary_food_type?.title
                      }
                      title={
                        props?.orderInfo?.restaurant?.primary_food_type?.title
                      }
                      style={{ width: "20%", height: "auto" }}
                    />
                    <div className="f10-400">
                      {props?.orderInfo?.restaurant?.primary_food_type?.title}
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {props?.orderInfo?.restaurant?.vendor_id?.has_admin_approved
                      ? "Active"
                      : "Inactive"}
                  </div>
                </td>
                <td
                  style={{ width: "15%" }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  <div
                    className="p-2 f10-700"
                    style={{
                      border: "1px solid #EE3A23",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    onClick={vendorDashboard(
                      props?.orderInfo?.restaurant?.vendor_id._id
                    )}
                  >
                    <Image
                      src={require("../../../../assets/images/ActionImages/image/onboarding.svg")}
                      alt="View"
                      title="View"
                      fluid
                      className="mr-2"
                      width="20px"
                    />
                    View Dashboard
                  </div>
                </td>
              </tr>
              {TrDetail && (
                <>
                  <tr className="sd_accordion_body">
                    <td style={{ width: "18%" }}>
                      <div className="f12-400">Contact</div>
                      <div className="d-flex align-items-center mt-2">
                        {/* <SuperAdminCall /> */}
                        {/* <CallingButtonPopup
                          buttonClass="smallButton"
                          sendData={formData}
                        /> */}
                        <CallingButtonPopup
                          sendData={makeCallingObject(props?.orderInfo)}
                        />
                        <SendSMS
                          mobile_number={
                            props?.orderInfo?.restaurant?.vendor_id
                              ?.mobile_number
                          }
                          country_code={
                            props?.orderInfo?.restaurant?.vendor_id
                              ?.country_code
                          }
                        />
                        <SuperAdminNotification />
                      </div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f12-400">Hours of Operation</div>
                      <div className="f12-400 mt-2">
                        {props?.orderInfo?.restaurant?.openStatus?.open
                          ? "Closes At"
                          : "Open At"}
                        :{" "}
                        {moment(
                          props?.orderInfo?.restaurant?.openStatus?.time,
                          ["HH:mm"]
                        ).format("hh:mm a")}
                        <br />
                        <Image
                          className="mr-2"
                          src={require("../../../../assets/images/Icon/clock.svg")}
                        />
                        {props?.orderInfo?.restaurant?.seatingWaitingTime}{" "}
                        <span style={{ color: "#F85032" }}>
                          {props?.orderInfo?.restaurant?.seatingWaitingTime ===
                            "00-00"
                            ? "WalkIn"
                            : "Wait"}
                        </span>
                      </div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f12-400">City/Location</div>
                      <div className="f12-400 mt-2">
                        {props?.orderInfo?.restaurant?.city} /{" "}
                        {props?.orderInfo?.restaurant?.area}
                      </div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f12-400">Member Since</div>
                      <div className="f12-400 mt-2">
                        {moment(props?.orderInfo?.restaurant?.createdAt).format(
                          "DD/MM/YYYY"
                        )}
                      </div>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
